<div [editableInStoryblok]="_editable()" [ngClass]="maxWidth" class="mx-auto">
	<h2 [ngClass]="headingSize()" data-test-class="running-head">
		{{ title }}
	</h2>
</div>
